import { ROUTES } from 'shared/constants';
import { GetRoutesFn, ProtectedRoute } from 'shared/routes/';

import { ExplorerNationCommunityProfilePage } from './pages/ExplorerNationCommunityProfilePage';
import { ExplorerNationPage } from './pages/ExplorerNationPage';
import { ExplorerNationProfilePage } from './pages/ExplorerNationProfilePage';

export const getExplorerRoutes: GetRoutesFn = () => [
  {
    routeComponent: ProtectedRoute,
    path: ROUTES.user.explorer.index,
    exact: true,
    component: ExplorerNationPage,
  },
  {
    routeComponent: ProtectedRoute,
    path: ROUTES.user.explorer.year,
    exact: true,
    component: ExplorerNationPage,
  },
  {
    routeComponent: ProtectedRoute,
    path: ROUTES.user.explorer.profile,
    exact: false,
    component: ExplorerNationProfilePage,
  },
  {
    routeComponent: ProtectedRoute,
    path: ROUTES.user.explorer.community,
    exact: false,
    component: ExplorerNationCommunityProfilePage,
  },
];
